import React from "react";
import ReactDOM from "react-dom/client";
import { useState } from "react";
import "./orep.css";
import Multiselect from "multiselect-react-dropdown";
import axios from "axios";
import { countriesTime } from "./countryTimeZones";

const DataExplorer = () => {
    const [IdCountry, setIdCountry] = useState([0]);
    const [diff, setDiff] = useState([]);
    const [Iddiff, setIddiff] = useState([]);
    const handleCountrySelection = (e) => {
        const value = e.target.value;
        setIdCountry(e.target.value);
        axios
            .get("https://tag4track.com:8001/timezones?id=" + value)
            .then((response) => {
                setDiff(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    };
    const [startTime, setStartTime] = useState(
        new Date().toLocaleString().slice(0, 16)
    );

    const [endTime, setEndTime] = useState(
        new Date(new Date() - 1).toLocaleString().slice(0, 16)
    );

    const [urlDownload, setUrlDownload] = useState("");
    const [devices, setDevices] = useState(["all"]);
    const [devices2, setDevices2] = useState(["all"]);
    const fetchDevices = async (id) => {
        const responseDevice = await axios.get(
            "https://tag4track.com:8001/getDevices",
            {
                params: {
                    id: id,
                },
                headers: {
                    accept: "application/json",
                },
            }
        );
        return responseDevice.data;
    };

    const buttonDevices = () => {
        const id = document.getElementById("idpdf").value;
        setDevices(["all"]);
        setDevices2(["all"]);
        fetchDevices(id)
            .then((response) => {
                setDevices([...devices, ...response]);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };
    const fetch = async (
        id_,
        dev_,
        st_,
        et_,
        interval_,
        agg_,
        temp_,
        Iddiff
    ) => {
        const response = await axios.get("https://tag4track.com:8001/run_script", {
            responseType: "blob",
            params: {
                id: id_,
                devices: dev_,
                startTime: st_,
                endTime: et_,
                interval: interval_,
                aggregation: agg_,
                temp: temp_,
                tz: Iddiff,
            },
            headers: {
                accept: "application/json",
            },
            timeout: 300000,
        });
        const pdfBlob = new Blob([response.data], {
            type: "application/pdf",
        });

        // Create a blob URL for the blob
        const pdfBlobUrl = URL.createObjectURL(pdfBlob);

        // Log or use pdfBlobUrl as needed
        console.log("Blob URL:", pdfBlobUrl);

        // Return the blob URL or data if you need to use it elsewhere
        return pdfBlobUrl;
    };

    const getResponse = () => {
        const id_ = document.getElementById("idpdf").value;
        // startTime,
        // endTime,
        const interval_ = document.getElementById("interval").value;
        const agg_ = document.getElementById("agg").value;
        const temp = document.getElementById("Temp").value;
        fetch(
            id_,
            devices2.join(","),
            startTime,
            endTime,
            interval_,
            agg_,
            temp,
            Iddiff
        )
            .then((response) => {
                setUrlDownload(response);
                return response;
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    return (
        <>
            <h1>Data Explorer through PDF</h1>
            <form type="submit">
                <input
                    type="number"
                    min="1"
                    placeholder="ID"
                    id="idpdf"
                ></input>
                <br></br>
                <div id="horizontal_div">
                    <Multiselect
                        isObject={false}
                        onRemove={(e) => setDevices2(e)}
                        onSelect={(e) => setDevices2(e)}
                        options={devices}
                        id="multi_1"
                        placeholder="Devices"
                    ></Multiselect>
                    <button type="button" id="submit" onClick={buttonDevices}>
                        Refresh
                    </button>
                    <button
                        type="button"
                        id="submit"
                        onClick={() => console.log(devices2)}
                    >
                        see
                    </button>
                </div>
                <br></br>
                <label>
                    Start Time
                    <input
                        type="datetime-local"
                        id="startTime"
                        onChange={
                            (e) =>
                                setStartTime(
                                    new Date(e.target.value).toLocaleString()
                                )
                            // console.log(startTime)
                        }
                        // defaultValue={today.toLocaleString()}
                    ></input>
                </label>
                <br></br>

                <label>
                    End Time
                    <input
                        type="datetime-local"
                        id="endTime"
                        onChange={
                            (e) =>
                                setEndTime(
                                    new Date(e.target.value).toLocaleString()
                                )
                            // console.log(endTime)
                        }
                        // defaultValue={yesterday.toLocaleString()}
                    ></input>
                </label>
                <br></br>
                <div>
                    <select
                        className="mb-3"
                        onChange={(e) => handleCountrySelection(e)}
                        id="CountryId"
                    >
                        <option>Select Country</option>
                        {countriesTime.map((country) => {
                            return (
                                <CountryOptions {...country} key={country.id} />
                            );
                        })}
                    </select>
                </div>
                <div>
                    <select
                        id="diffId"
                        onChange={(e) => {
                            setIddiff(e.target.value);
                        }}
                    >
                        <option>Select Time Zone</option>
                        {diff.map((city) => {
                            return <DiffOptions {...city} key={city.id} />;
                        })}
                    </select>
                </div>

                <label>
                    Temp or Humidity
                    <select id="Temp">
                        <option value="pdfTempHumidity">
                            pdf Temp & Humidity
                        </option>
                        <option value="pdfTempHumidityNoSummary">
                            pdf Temp & Humidity without summary
                        </option>
                        <option value="pdfTempHumidityNoGraph">
                            pdf Temp & Humidity no graph
                        </option>
                        <option value="pdfTempHumidityOnlyTables">
                            pdf Temp & Humidity tables only
                        </option>
                        <option value="CSVTempHumidity">
                            CSV Temp & Humidity
                        </option>
                        <option value="HTMLTempHumidity">
                            HTML Temp & Humidity
                        </option>

                        <option value="pdfTemp">pdf Temp</option>
                        <option value="pdfTempNoSummary">
                            pdf Temp without summary
                        </option>
                        <option value="pdfTempNoGraph">
                            pdf Temp no graph
                        </option>
                        <option value="pdfTempOnlyTables">
                            pdf Temp tables only
                        </option>
                        <option value="CSVTemp">CSV Temp</option>
                        <option value="HTMLTemp">HTML Temp</option>

                        <option value="pdfHumidity">pdf Humidity</option>
                        <option value="pdfHumidityNoSummary">
                            pdf Humidity without summary
                        </option>
                        <option value="pdfHumidityNoGraph">
                            pdf Humidity no graph
                        </option>
                        <option value="pdfHumidityOnlyTables">
                            pdf Humidity tables only
                        </option>
                        <option value="CSVHumidity">CSV Humidity</option>
                        <option value="HTMLHumidity">HTML Humidity</option>
                    </select>
                </label>
                <br></br>
                <input
                    type="number"
                    min="1"
                    placeholder="Interval in min"
                    id="interval"
                ></input>
                <br></br>
                <label>
                    Aggregation
                    <select id="agg">
                        <option value="mean">Mean</option>
                        <option value="max">Max</option>
                        <option value="min">Min</option>
                        <option value="mode">Mode</option>
                        <option value="median">Median</option>
                    </select>
                </label>
                <br></br>
            </form>
            <br></br>
            <br></br>
            {/* <label>
                Font Size
                <select id="fnz">
                    <option value="1">1</option>
                    <option value="1.1">1.1</option>
                    <option value="1.2">1.2</option>
                    <option value="1.3">1.3</option>
                    <option value="1.4">1.4</option>
                    <option value="1.5">1.5</option>
                </select>
            </label> */}
            <br></br>
            <button id="submit" onClick={getResponse}>
                Submit
            </button>
            {urlDownload !== "" ? (
                <a href={urlDownload}>Click to Download</a>
            ) : null}
            <br></br>
            <br></br>
            <br></br>
            <footer>
                <div>
                    For More information please contact us on
                    reportmaster@tag4track.com
                </div>
            </footer>
        </>
    );
};

const CountryOptions = ({ id, country }) => {
    return (
        <option value={id} id="countryID2">
            {country}
        </option>
    );
};

const DiffOptions = ({ id, UTC }) => {
    return (
        <option value={UTC} id="stateID2">
            {UTC}
        </option>
    );
};
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(<DataExplorer />);
export default DataExplorer;
